<mat-date-range-input [rangePicker]="pickerBasicRange" [formGroup]="formGroup">
  <input
    matStartDate
    placeholder="Start date"
    i18n-placeholder
    formControlName="dateFrom"
    [formlyAttributes]="field"
  />
  <input
    matEndDate
    placeholder="End date"
    i18n-placeholder
    formControlName="dateTo"
    [formlyAttributes]="field"
  />
  <formly-group [field]="$any(field)"></formly-group>
</mat-date-range-input>
<ng-template #datepickerToggle>
  <mat-datepicker-toggle
    matSuffix
    [for]="pickerBasicRange"
    [disabled]="props.disabled"
  >
    <mat-icon matDatepickerToggleIcon svgIcon="calendar"> </mat-icon>
  </mat-datepicker-toggle>
</ng-template>
<mat-date-range-picker
  #pickerBasicRange
  [color]="props.color"
  [dateClass]="$any(props.datepickerOptions?.dateClass)"
  [disabled]="props.datepickerOptions?.disabled"
  [opened]="props.datepickerOptions?.opened"
  [panelClass]="props.datepickerOptions?.panelClass || ''"
  [startAt]="props.datepickerOptions?.startAt"
  [startView]="$any(props.datepickerOptions?.startView)"
  [touchUi]="props.datepickerOptions?.touchUi"
  [calendarHeaderComponent]="
    $any(props.datepickerOptions).calendarHeaderComponent
  "
  (monthSelected)="
    $any(props.datepickerOptions).monthSelected(field, $event, pickerBasicRange)
  "
  (yearSelected)="
    props.datepickerOptions?.yearSelected(field, $event, pickerBasicRange)
  "
  (opened)="$any(props.datepickerOptions).opened = true"
  (closed)="$any(props.datepickerOptions).opened = false"
>
</mat-date-range-picker>
